
export function FilePreview({ file, onRemove }: { file: File; onRemove: (file: File) => void; }) {
    const fileSize = file.size / 1024 / 1024; // Convert bytes to MB

    return (
        <div className="flex items-center justify-between">
            <div className="flex items-center gap-2 mx-4">
                <p className="text-gray-500">{file.name}</p>
                <p className="text-gray-500">{fileSize.toFixed(2)} MB</p>
            </div>

            <button className="text-red-500" onClick={(e) => { e.stopPropagation(); onRemove(file) }}>
                X
            </button>
        </div>
    );
}
